import React, { useEffect, useState } from 'react'
import { useQuery } from 'react-query'
import { useParams } from 'react-router-dom'
import { getSubHeaderLoans } from 'services/loans'

export default function useGetSubHeaderLoans(loan: number | undefined) {
    const [allData, setAllData] = useState<ISubHeaderLoan[]>([])
    const [page, setPage] = useState<number>(1)
    const [subHeaderData, setSubheaderData] = useState<
        ISubHeaderLoan | undefined
    >()
    const { moneyPool, loanId } = useParams()
    const { data, isLoading } = useQuery(
        ['sub-header-loans-page', moneyPool, page],
        getSubHeaderLoans
    )

    useEffect(() => {
        if (data && data.next) {
            setPage(page + 1)
        }
        if (data) {
            setAllData([...allData, ...data.results])
        }
    }, [data])

    useEffect(() => {
        if (data && loan) {
            const result = allData.find((item) => item.id === loan)
            setSubheaderData(result)
        }
    }, [data, loan])
    return { subHeaderData }
}
